import { Avatar, Button, Col, Collapse, DatePicker, Input, Row, Select } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GeneralBloc from "../../../../bloc/general_bloc";
import ProfileBloc from "../../../../bloc/profile_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import App_header from "../../../component/app_header/app_header";
import App_header_title_simple from "../../../component/app_header_title/app_header_title_simple";
import Base_screen from "../../base/base_screen/base_screen";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import HomeBloc from "../../../../bloc/home_bloc";
import Config from "../../../../Config";

import "./quotation_form.css";
import AppSteps from "../../../component/app_steps/app_steps2";
import AppTextField from "../../../component/app_text_field/app_text_field";
import AppSelectField from "../../../component/app_select_field/app_select_field";
import UtilBloc from "../../../../bloc/util_bloc";
import AppModal from "../../../component/app_modal/app_modal";
import AppFieldError from "../../../component/form/app_field_error/app_field_error";
import AppSelectButton from "../../../component/app_select_button/app_select_button";
import QuotationBloc from "../../../../bloc/quotation_bloc";
import AppBottomBar from "../../../component/app_bottom_bar/app_bottom_bar";
import { isEmptyObject } from "jquery";
import AppLoadingDialog from "../../../dialog/app_loading_dialog";
import moment from "moment";
import FormsBloc from "../../../../bloc/forms_bloc";

const StepData = [
    {
        title: 'Personal Details',
        status: 'process'
    },
    {
        title: 'Financing Details'
    },
    {
        title: 'Takaful Details'
    },
    {
        title: 'Review and Submit'
    },
]

class FinancingDetailsForm extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            section: this.props.match.params.section,
            keyword: null,
            financingInstitute: null,
            financed: null,
            financingAmount: null,
            financingPercentage: null,
            profitRate: '7',
            coveredFinancingAmount: null,
            loanTerm: null,
            financingPeriod: null,
            defermentPeriod: null,
            criticalIllnessProtection: null,
            criticalIllnessBenefit: null,
            paymentMethod: null,
            financingReferenceNo: null,
            isEdit: false,
            isSaveModalOpen: false,
            isDiscardModalOpen: false,
            errorFinancingInstituteInd: false,
            errorFinanceInd: false,
            errorFinancingAmountInd: false,
            errorProfitRateInd: false,
            errorFinancingPercentageInd: false,
            errorPaymentMethodInd: false,
            errorFinancingReferenceNoInd: false,
            errorCriticalIllnessProtectionInd: false,
            errorCoveredFinancingAmouontInd: false,
            errorLoanTermInd: false,
            errorFinancingPeriodInd: false,
            errorDefermentPeriodInd: false,
            errorCriticalIllnessBenefitInd: false,
            errorMessage: 'Fill in the required field.',
            editErrorModal: false,
            errorModal: false,
            message: ''
        };
    }

    getQuotationId() {
        return this.props.match.params.itemId;
    }

    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        this.getFormData();
    }

    async getFormData() {
        this.setState({ loading: true, currentBank: await this.getSelectedBank(), financingInstitute: await this.companyNameByEntity() });
        let personalFormData = await QuotationBloc.getFormDetailQuotation(this.getQuotationId(), Config.quotation.formLabelMapping.personalDetails.label);
        let formData = await QuotationBloc.getFormDetailQuotation(this.getQuotationId(), Config.quotation.formLabelMapping.financingDetails.label);
        let selectedBank = await this.getSelectedBank();

        if (!isEmptyObject(personalFormData)) {
            this.setState({ age: personalFormData.anb, dob: personalFormData.dob });
        }

        if (personalFormData?.dob && formData?.defermentPeriod) {
            this.getLoanTermOptions(personalFormData.dob, formData.defermentPeriod);
        }

        if (!isEmptyObject(formData)) {
            //Check is Editable 
            let editable = await QuotationBloc.editGeneratedQuotation(this.getQuotationId());
            if (editable.success) {
                this.setState({
                    loading: false,
                    isEdit: true,
                    formData: formData,
                    financingInstitute: formData.financingBank,
                    financed: formData.financed || (selectedBank === 'MBS' ? 'No' : null),
                    financingReferenceNo: formData.financingReferenceNo,
                    paymentMethod: formData.paymentMethod || (selectedBank === 'MBS' ? 'DIRECT' : null),
                    financingAmount: formData.financingAmount,
                    profitRate: (formData.profitRate * 100).toFixed(2),
                    coveredFinancingAmount: formData.coveredFinancingAmount,
                    loanTerm: formData.loanTerm,
                    defermentPeriod: formData.defermentPeriod,
                    criticalIllnessBenefit: (formData.criticalIllnessBenefit * 100).toFixed(2),
                    criticalIllnessProtection: formData.criticalIllnessProtection ? formData.criticalIllnessProtection : selectedBank === 'MBS' ? 'No' : null,
                })
            } else {
                this.setState({
                    loading: false,
                    editErrorModal: true,
                    message: 'This quotation cannot be edit or update.'
                })
            }

        } else {
            this.setState({
                loading: false,
                criticalIllnessProtection: selectedBank === 'MBS' ? 'No' : null,
                paymentMethod: selectedBank === 'MBS' ? 'DIRECT' : null,
                financed: selectedBank === 'MBS' ? 'No' : null,
            })
        }
    }

    async getSelectedBank() {
        return await JSON.parse(sessionStorage.getItem("selectedBank"))?.id || this.props?.userGlobal?.roles[0]?.entity;
    }

    async companyNameByEntity() {
        let selectedBank = await this.getSelectedBank();
        if (selectedBank) {
            switch (selectedBank) {
                case Config.entity.hsbc.code:
                    return "HSBC Amanah";
                case Config.entity.alliance.code:
                    return "Alliance Islamic Bank Berhad";
                case Config.entity.mbsb.code:
                    return "MBSB Bank Berhad";
                default:
                    return null;
            }
        } else {
            return "Alliance Islamic Bank Berhad";
        }

    }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    async getFinanceInstituteData() {
        let financeInstitute = await FormsBloc.getFinanceInstituteList();
        this.setState({ financeInstituteOpt: financeInstitute.data });
    }

    getLoanTermOptions = async (dob, period) => {
        let loanTermOptions = await QuotationBloc.getLoanTermListing(dob ? moment(dob).format("YYYY-MM-DD") : '', period, await this.getSelectedBank());
        if (loanTermOptions?.success) {
            let options = [];
            for (let i = 5; i <= (loanTermOptions?.data || 35); i++) {
                options.push({ label: i.toString(), value: i.toString() });
            }
            this.setState({ loanTermOptions: options, loanTerm: null });
        }
    }

    handleFinancedChange = (financed) => {
        this.setState({ financed: financed });
    }

    handlePaymentMethodChange = (paymentMethod) => {
        this.setState({ paymentMethod: paymentMethod });
    }

    handleFinancingInstituteChange = (financingInstitute) => {
        this.setState({ financingInstitute: financingInstitute });
    }

    handleFinancingAmountChange = (amount) => {
        if (amount) {
            let value = amount;
            if (/^\d*\.?\d*$/.test(value)) {
                this.setState({ financingAmount: value });
            }
        } else {
            this.setState({ financingAmount: amount });
        }
    }

    handleFinancingReferenceNoChange = (refNo) => {
        this.setState({ financingReferenceNo: refNo });
    }

    handleFinancingPercentageChange = (percentage) => {
        if (percentage) {
            let value = percentage;
            if (/^\d*\.?\d*$/.test(value)) {
                this.setState({ financingPercentage: value });
            }
        } else {
            this.setState({ financingPercentage: percentage });
        }
    }

    handleProfitRateChange = (rate) => {
        this.setState({ profitRate: rate });
    }

    handleCoveredFinancingAmountChange = (amount) => {
        if (amount) {
            let value = amount;
            if (/^\d*\.?\d*$/.test(value)) {
                let isValueLargerThanFinancingAmount = this.state.financingAmount ? Number(value) > Number(this.state.financingAmount) : false;
                this.setState({
                    coveredFinancingAmount: value,
                    errorCoveredFinancingAmouontInd: isValueLargerThanFinancingAmount ? true : false,
                    errorMessage: isValueLargerThanFinancingAmount ? 'Covered financing amount cannot be larger than financing amount' : ''
                });
            }
        } else {
            this.setState({ coveredFinancingAmount: amount });
        }
    }

    handleLoanTermChange = (item) => {
        this.setState({ loanTerm: item })
    }

    handleFinancingPeriodChange = (period) => {
        this.setState({ financingPeriod: period });
    }

    handleDefermentPeriodChange = async (period) => {
        this.setState({ defermentPeriod: period });
        await this.getLoanTermOptions(this.state.dob, period);
    }

    handleCriticalIllnessProtectionChange = (item) => {
        this.setState({ criticalIllnessProtection: item });
        if (item === 'No') {
            this.setState({ criticalIllnessBenefit: null });
        }
    }

    handleCriticalIllnessBenefitChange = (item) => {
        if (item) {
            let value = item;
            if (/^\d*\.?\d*$/.test(value)) {
                this.setState({ criticalIllnessBenefit: value });
            }
        } else {
            this.setState({ criticalIllnessBenefit: item });
        }
    }

    // control save & close modal
    handleSaveModalOpen = () => {
        this.setState({ isSaveModalOpen: true })
    }

    handleSaveModalClose = () => {
        this.setState({ isSaveModalOpen: false })
    }

    // control discard modal
    handleDiscardModalOpen = () => {
        this.setState({ isDiscardModalOpen: true })
    }

    handleDiscardModalClose = () => {
        this.setState({ isDiscardModalOpen: false })
    }

    getBackToQuotationDashboard = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation}`
    }

    getBackToPersonalDetails = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_personal_details}/${this.getQuotationId()}`
    }

    handleStopWithoutSaving = () => {
        this.getBackToQuotationDashboard();
    }

    handleValidateForm = () => {
        const {
            financed, financingAmount, profitRate, coveredFinancingAmount, loanTerm,
            defermentPeriod, criticalIllnessBenefit, criticalIllnessProtection, paymentMethod, financingReferenceNo
        } = this.state;
        let isCoveredFinancingAmountLargerThanFinancingAmount = financingAmount && coveredFinancingAmount ? Number(coveredFinancingAmount) > Number(financingAmount) : false;
        this.setState({
            errorFinanceInd: UtilBloc.isNullOrEmpty(financed) ? true : false,
            errorFinancingAmountInd: UtilBloc.isNullOrEmpty(financingAmount) ? true : false,
            errorPaymentMethodInd: financed === 'No' ? UtilBloc.isNullOrEmpty(paymentMethod) ? true : false : false,
            errorFinancingReferenceNoInd: UtilBloc.isNullOrEmpty(financingReferenceNo) ? true : false,
            // errorFinancingPercentageInd: UtilBloc.isNullOrEmpty(financingPercentage) ? true : false,
            errorProfitRateInd: UtilBloc.isNullOrEmpty(profitRate) ? true : false,
            errorCoveredFinancingAmouontInd: UtilBloc.isNullOrEmpty(coveredFinancingAmount) ? true : isCoveredFinancingAmountLargerThanFinancingAmount ? true : false,
            errorLoanTermInd: UtilBloc.isNullOrEmpty(loanTerm) ? true : false,
            // errorFinancingPeriodInd: UtilBloc.isNullOrEmpty(financingPeriod) ? true : false,
            errorDefermentPeriodInd: UtilBloc.isNullOrEmpty(defermentPeriod) ? true : false,
            errorCriticalIllnessBenefitInd: this.state.currentBank !== 'MBS' ? UtilBloc.isNullOrEmpty(criticalIllnessBenefit) || Number(criticalIllnessBenefit) <= 0 ? true : false : false,
            errorCriticalIllnessProtectionInd: this.state.currentBank !== 'MBS' ? UtilBloc.isNullOrEmpty(criticalIllnessProtection) ? true : false : false,
        })
        if (
            !UtilBloc.isNullOrEmpty(financed) && ((financed === 'No' && !UtilBloc.isNullOrEmpty(paymentMethod)) || (financed === 'Yes')) && !UtilBloc.isNullOrEmpty(financingAmount) && !UtilBloc.isNullOrEmpty(profitRate)
            && !UtilBloc.isNullOrEmpty(coveredFinancingAmount) && !UtilBloc.isNullOrEmpty(loanTerm) && !UtilBloc.isNullOrEmpty(defermentPeriod) && !UtilBloc.isNullOrEmpty(financingReferenceNo)
            && (this.state.currentBank !== 'MBS' ? (criticalIllnessBenefit === 'Yes' ? !UtilBloc.isNullOrEmpty(criticalIllnessBenefit) && !UtilBloc.isNullOrEmpty(criticalIllnessProtection) : true) : true) && !isCoveredFinancingAmountLargerThanFinancingAmount
        ) {
            return true;
        } else {
            return false;
        }
    }

    handleSaveCurrentStep() {
        this.handleFormSubmit('save');
    }

    handleNextStep() {
        const isValidate = this.handleValidateForm();
        if (isValidate) {
            this.handleFormSubmit('next');
        }

    }

    async handleFormSubmit(type) {
        this.setState({ loading: true });
        let data = Config.quotation.formDataMapping.financialDetails;
        data.financed = this.state.financed ? this.state.financed : '';
        data.financingReferenceNo = this.state.financingReferenceNo ? this.state.financingReferenceNo : '';
        data.financingAmount = this.state.financingAmount ? Number(this.state.financingAmount).toFixed(2).toString() : '';
        data.financingBank = this.state.financingInstitute || this.companyNameByEntity() || '';
        data.paymentMethod = this.state.paymentMethod || '';
        data.profitRate = this.state.profitRate ? (this.state.profitRate / 100).toString() : '';
        data.coveredFinancingAmount = this.state.coveredFinancingAmount ? Number(this.state.coveredFinancingAmount).toFixed(2).toString() : '';
        data.loanTerm = this.state.loanTerm ? this.state.loanTerm : '';
        data.defermentPeriod = this.state.defermentPeriod ? this.state.defermentPeriod : '';

        data.sourceChannel = this.state.financingInstitute ? this.state.financingInstitute === 'MBSB Bank Berhad' ? 'MBS' :
            (this.state.financingInstitute === 'Alliance Bank Malaysia Berhad' ? 'ABMB' : 'AIS') : '';

        if (this.state.currentBank !== 'MBS') {
            data.criticalIllnessBenefit = this.state.criticalIllnessBenefit ? (this.state.criticalIllnessBenefit / 100).toString() : '0.00';
            data.criticalIllnessProtection = this.state.criticalIllnessProtection ? this.state.criticalIllnessProtection : "No";
        }

        let response = await QuotationBloc.saveForm(this.getQuotationId(), 'FINANCING_DETAILS', data);
        if (response.success) {
            if (type == 'next') {
                let calculation = await QuotationBloc.getCalculatedContributionAmount(this.getQuotationId());
                if (calculation?.success) {
                    window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_takaful_details}/${this.getQuotationId()}`
                } else {
                    this.setState({
                        loading: false,
                        errorModal: true,
                        title: 'Error',
                        message: calculation.message
                    })
                }
            } else {
                this.getBackToQuotationDashboard();
            }
        } else {
            this.setState({
                loading: false,
                errorModal: true,
                title: 'Error',
                message: response.message
            })
        }
    }

    renderBottomBar = () => {
        return (
            <AppBottomBar
                enable={true}
                lableDiscard={'Discard'}
                lableSaveAndClose={'Save & Close'}
                lableNext={'Next'}
                alignContent={"right"}
                buttonWidth={"auto"}
                onNext={(e) => { this.handleNextStep() }}
                onDiscard={(e) => this.handleDiscardModalOpen()}
                onSaveAndClose={(e) => this.handleSaveModalOpen()}
            />
        )
    }

    financingBank() {
        return (
            <AppSelectField
                title={'Financing Institution'}
                value={this.state.financingInstitute || this.companyNameByEntity()}
                placeholder={'Select financing institution...'}
                // options={this.state.financingInstituteOptions || []}
                options={this.state.currentBank === 'MBS' ? Config.quotation.optionItem.financingInstitutionMBSB : Config.quotation.optionItem.financingInstitutionAlliance}
                onChange={this.handleFinancingInstituteChange}
                error={this.state.errorFinancingInstituteInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    financed() {
        return (
            <AppSelectButton
                title={'Financed'}
                value={this.state.financed}
                handleNegativePress={() => this.handleFinancedChange('No')}
                handlePositivePress={() => this.handleFinancedChange('Yes')}
                error={this.state.errorFinanceInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    paymentMethod() {
        return (
            <AppSelectField
                title={'Payment Method'}
                value={this.state.paymentMethod}
                placeholder={'Select payment method...'}
                // options={this.state.paymentMethodOptions || []}
                options={Config.quotation.optionItem.paymentMethod}
                onChange={this.handlePaymentMethodChange}
                error={this.state.errorPaymentMethodInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    financingAmount() {
        return (
            <AppTextField
                title={'Financing Amount'}
                type={'text'}
                placeholder={'0.00'}
                prefix={'RM '}
                value={this.state.financingAmount}
                onChange={this.handleFinancingAmountChange}
                error={this.state.errorFinancingAmountInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    financingReferenceNo() {
        return (
            <AppTextField
                title={'Financing Reference No'}
                type={'text'}
                placeholder={'Enter financing reference number...'}
                value={this.state.financingReferenceNo}
                onChange={this.handleFinancingReferenceNoChange}
                error={this.state.errorFinancingReferenceNoInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    financingPercentage() {
        return (
            <AppTextField
                title={'Financing Percentage'}
                type={'text'}
                placeholder={'0'}
                suffix={'%'}
                value={this.state.financingPercentage}
                onChange={this.handleFinancingPercentageChange}
                error={this.state.errorFinancingPercentageInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    profitRate() {
        return (
            <AppTextField
                title={'Profit Rate'}
                type={'text'}
                placeholder={'0'}
                suffix={'%'}
                disabled={true}
                value={this.state.profitRate}
                onChange={this.handleProfitRateChange}
                error={this.state.errorProfitRateInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    coveredFinancingAmount() {
        return (
            <AppTextField
                title={'Covered Financing Amount'}
                type={'text'}
                placeholder={'0.00'}
                prefix={'RM '}
                value={this.state.coveredFinancingAmount}
                onChange={this.handleCoveredFinancingAmountChange}
                error={this.state.errorCoveredFinancingAmouontInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    loanTerm() {
        return (
            <AppSelectField
                title={'Loan Term'}
                value={this.state.loanTerm}
                placeholder={'Select loan term...'}
                options={this.state.loanTermOptions || []}
                onChange={this.handleLoanTermChange}
                error={this.state.errorLoanTermInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    financingPeriod() {
        return (
            <AppTextField
                title={'Financing Period'}
                type={'number'}
                placeholder={'0'}
                suffix={'Years'}
                value={this.state.financingPeriod}
                onChange={this.handleFinancingPeriodChange}
                error={this.state.errorFinancingPeriodInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    defermentPeriod() {
        return (
            <AppSelectField
                title={'Deferment Period'}
                type={'text'}
                value={this.state.defermentPeriod}
                placeholder={'Select deferment period...'}
                options={this.state.currentBank === 'MBS' ? Config.quotation.optionItem.defermentPeriodMbsb : Config.quotation.optionItem.defermentPeriodAlliance}
                onChange={this.handleDefermentPeriodChange}
                error={this.state.errorDefermentPeriodInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    criticalIllnessProtection() {
        return (
            <AppSelectButton
                title={'Critical Illness Protection'}
                value={this.state.criticalIllnessProtection}
                handleNegativePress={() => this.handleCriticalIllnessProtectionChange('No')}
                handlePositivePress={() => this.handleCriticalIllnessProtectionChange('Yes')}
                disabled={this.getSelectedBank() === 'MBS' ? true : false}
                error={this.state.errorCriticalIllnessProtectionInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    criticalIllnessBenefit() {
        return (
            <AppTextField
                title={'Critical Illness Benefit'}
                type={'text'}
                placeholder={'0'}
                suffix={'%'}
                value={this.state.criticalIllnessBenefit}
                onChange={this.handleCriticalIllnessBenefitChange}
                error={this.state.errorCriticalIllnessBenefitInd}
                errorMessage={Number(this.state.criticalIllnessBenefit) <= 0 ? 'Invalid benefit amount' : this.state.errorMessage}
            />
        )
    }

    loadingContent() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }

    render() {
        return (
            <>
                <Base_screen
                    listener={() => {
                        this.getEntity();
                    }}
                >
                    <>
                        <App_header
                            data={this.getUserDataHeader()}
                            route={this.getEntity()}
                        >
                            <div style={{ width: '60%' }}>
                                <AppSteps
                                    direction="horizontal"
                                    current={1}
                                    items={StepData}
                                />
                            </div>

                        </App_header>
                        <div
                            style={{
                                marginTop: 110,
                                paddingLeft: 42,
                                paddingRight: 42,
                                paddingBottom: 150
                            }}
                        >
                            {this.state.loading && this.loadingContent()}
                            <div className="row m-0 w-100">
                                <App_header_title_simple
                                    title={'Step 2 - Financing Details'}
                                    description={<span style={{ color: 'red', fontStyle: 'italic' }}>All fields are required</span>}
                                    handleBack={() => this.getBackToPersonalDetails()}
                                />
                            </div>
                            <div className="w-100 form_container m-2" >
                                <div className="row m-0 w-100">
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                        {this.financingBank()}
                                    </div>
                                </div>
                                <div className="row m-0 mt-2 w-100">
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                        {this.financed()}
                                    </div>
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                        {this.state.financed === 'No' && this.paymentMethod()}
                                    </div>
                                </div>
                                <div className="row m-0 mt-2 w-100">
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                        {this.financingAmount()}
                                    </div>
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                        {this.financingReferenceNo()}
                                    </div>
                                </div>
                                <div className="row m-0 mt-2 w-100">
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                        {this.profitRate()}
                                    </div>
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                        {this.coveredFinancingAmount()}
                                    </div>
                                </div>
                                <div className="row m-0 mt-2 w-100">
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                        {this.defermentPeriod()}
                                    </div>
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                        {this.loanTerm()}
                                    </div>
                                </div>
                                {
                                    this.state.currentBank !== 'MBS' &&
                                    <div className="row m-0 mt-2 w-100">
                                        <div className="col-lg-6 col-sm-12 pr-3 pl-0  pr-1 ">
                                            {this.state.financingAmount && this.criticalIllnessProtection()}
                                        </div>
                                        {
                                            this.state.criticalIllnessProtection == 'Yes' &&
                                            <div className="col-lg-6 col-sm-12 pr-3 pl-0   ">
                                                {this.criticalIllnessBenefit()}
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                        {this.renderBottomBar()}
                        <AppModal
                            open={this.state.isSaveModalOpen}
                            handleModalClose={this.handleSaveModalClose}
                            width={'50%'}
                            title={'Do you want to stop?'}
                            subtitle={'If you stop without saving, you will loose any progress you’ve made.'}
                            negativeButtonText={'Stop without Saving'}
                            positiveButtonText={'Save & Close'}
                            handleNegativePress={() => this.handleStopWithoutSaving()}
                            handlePositivePress={() => this.handleSaveCurrentStep()}
                            closable={false}
                        >
                        </AppModal>
                        <AppModal
                            open={this.state.isDiscardModalOpen}
                            handleModalClose={this.handleDiscardModalClose}
                            width={'50%'}
                            title={'Do you want to discard?'}
                            subtitle={'If you discard without saving, you will loose any progress you’ve made.'}
                            negativeButtonText={'Stop without Saving'}
                            positiveButtonText={'Save & Close'}
                            handleNegativePress={() => this.handleStopWithoutSaving()}
                            handlePositivePress={() => this.handleSaveCurrentStep()}
                            closable={false}
                        />
                        <AppModal
                            open={this.state.editErrorModal}
                            handleModalClose={() => this.setState({ editErrorModal: false })}
                            width={'50%'}
                            title={'Cannot be Edit/Update'}
                            subtitle={'This quotation cannot be update or edit'}
                            positiveButtonText={'Back'}
                            handlePositivePress={() =>
                                window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation}`
                            }
                            closable={false}
                        />
                        <AppModal
                            open={this.state.errorModal}
                            handleModalClose={() => this.setState({ errorModal: false })}
                            width={'50%'}
                            title={this.state.title}
                            subtitle={this.state.message}
                            positiveButtonText={'Close'}
                            handlePositivePress={() => this.setState({ errorModal: false })}
                            closable={false}
                        />
                    </>
                </Base_screen>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(FinancingDetailsForm));
